import styled from '@emotion/styled';
import {
  APPEND_PAGES_COUNT,
  EventListItem,
  MergeableEventListItem,
  Schedule,
} from '../reducer';
import { useCallback, useContext, useEffect } from 'react';
import { CalendarContext, setCurrentPage } from '../reducer/CalendarContext';
import DayTimeGridComp from '../DayTimeGrid';
import DayTimeGridRulerComp from '../DayTimeGridRuler';
import { scrollToNow } from '../reducer/useCalendarProvider';

interface Props {
  onClickEvent?: (event: MergeableEventListItem, el: HTMLElement) => void;
  onUpdateSchedule?: (schedule: Schedule) => void;
  onClickBookingSlot?: (event: EventListItem) => void;
  selectedEventId?: string;
  className?: string;
  isLoading?: boolean;
}
const Component = (props: Props) => {
  const { state, dispatch } = useContext(CalendarContext);

  const onScrollDayTimeGrid = useCallback(
    (e: any) => {
      if (!state.allDayTimeGridRef?.current) return;
      if (!state.weekdayHeaderRef?.current) return;
      const left = e.target.scrollLeft;
      state.allDayTimeGridRef.current.scrollLeft = left;
      state.weekdayHeaderRef.current.scrollLeft = left;

      if (state.isDisableHorizontalScroll) return;
      if (left % state.pageWidth === 0) {
        // ページ数を計算する
        const page = left / state.pageWidth;
        if (page !== state.currentPage) {
          dispatch(setCurrentPage(page));
        }
      }
    },
    [
      state.allDayTimeGridRef?.current,
      state.weekdayHeaderRef?.current,
      state.pageWidth,
      state.currentPage,
      state.showRange,
      state.pages,
    ],
  );

  useEffect(() => {
    if (!state.dayTimeGridRef?.current) return;
    state.dayTimeGridRef.current.onscroll = onScrollDayTimeGrid;
  }, [state.dayTimeGridRef?.current, onScrollDayTimeGrid]);

  // 初回表示位置
  useEffect(() => {
    if (state.isAutoScrollOnInit) {
      scrollToNow(state.timeZone);
    }
  }, []);

  // ページ移動時
  useEffect(() => {
    if (!state.dayTimeGridRef?.current) return;
    // SET_CURRENT_PAGEで一番最初にいったら元の日時のでページまで戻す
    if (state.currentPage === 0) {
      state.dayTimeGridRef!.current.scrollLeft =
        state.pageWidth * APPEND_PAGES_COUNT;
      dispatch(setCurrentPage(APPEND_PAGES_COUNT));
    }
  }, [state.currentPage, state.pageWidth, state.dayTimeGridRef?.current]);

  if (!state.isInit) return null;

  return (
    <DayTimeGridContainer className={props.className}>
      <DayTimeGridRulerComp isLoading={props.isLoading} />
      <HorizontalParentScroller
        ref={state.dayTimeGridRef}
        scrollerWidth={state.containerWidth}
        rulerWidth={state.rulerWidth}
        isDisableScroll={state.isDisableHorizontalScroll}
      >
        {state.pages.map((startedAt, page) => (
          <HorizontalParentScrollerItem key={page}>
            <DayTimeGridComp
              startedAt={startedAt}
              onClickEvent={props.onClickEvent}
              selectedEventId={props.selectedEventId}
              onUpdateSchedule={props.onUpdateSchedule}
              onClickBookingSlot={props.onClickBookingSlot}
              isLoading={props.isLoading}
            />
          </HorizontalParentScrollerItem>
        ))}
      </HorizontalParentScroller>
    </DayTimeGridContainer>
  );
};
const DayTimeGridContainer = styled.div`
  display: flex;
  overflow-x: hidden;
`;
export const HorizontalScroller = styled.div<{
  scrollerWidth?: string | null;
  rulerWidth: number;
}>`
  display: flex;
  transform: translate3d(0px, 0, 0);
  width: ${(props) =>
    props.scrollerWidth &&
    `calc(${props.scrollerWidth} - ${props.rulerWidth}px)`};
  overflow-x: auto;
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  /* will-change: transform, scroll-position; */
`;
const HorizontalScrollerItem = styled.div`
  display: flex;
  width: inherit;
  /* will-change: transform, scroll-position; */
`;
const HorizontalParentScroller = styled(HorizontalScroller)<{
  isDisableScroll: boolean;
}>`
  scroll-snap-type: x mandatory;
  overflow-x: ${(props) => (props.isDisableScroll ? 'hidden' : 'auto')};
`;
const HorizontalParentScrollerItem = styled(HorizontalScrollerItem)`
  scroll-snap-align: start;
`;

export default Component;
